import { atom, selector } from "recoil"

type PiPParamsAtomType = {
  isRedirected?: boolean
  isActivePiP?: boolean
  coverImage?: any
}

const pipParamsAtom = atom<PiPParamsAtomType>({
  key: "pipParamsAtom",
  default: { isRedirected: false, isActivePiP: false, coverImage: "" }
})

export const pipParamsSelector = selector<PiPParamsAtomType>({
  key: "pipParamsSelector",
  get: ({ get }) => get(pipParamsAtom),
  set: ({ get, set }, newPiPParams) =>
    set(pipParamsAtom, { ...get(pipParamsAtom), ...newPiPParams })
})
